import AemButton from '@/components/Aem/AemButton';
import {AppImage} from '@/components/Image';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import {useJourneyInfo} from '@/hooks/loyalty/dataHooks';
import appContent from '@/services/content/appContent';
import {formatBadgeImageUrl, getAchievedBadgeImage} from '@/services/loyalty/badgeUtils';
import {LoyaltyPopupTemplate} from '@/views/Loyalty/PopupTemplates/primitives';

import Background from './Background.jpg';

const EARN_BADGE_TEMPLATE_BADGE_IMAGE_SIZE = 512;

interface CompleteTaskTemplateProps {
    loyaltyInfo?: {
        journeyId: string;
    };
    subTitle?: string;
    title?: string;
}

export const EarnBadgeTemplate = ({loyaltyInfo, subTitle, title}: CompleteTaskTemplateProps) => {
    const {currentLevelBadge, badgeId, journeyName, journeyId} = useJourneyInfo(loyaltyInfo?.journeyId) || {};
    const {description, button, externalLink} = appContent.getEarnBadgeContent() || {};

    const badgeImage = getAchievedBadgeImage(currentLevelBadge);
    const formattedBadgeImageUrl = formatBadgeImageUrl(
        badgeImage?.imageURL,
        EARN_BADGE_TEMPLATE_BADGE_IMAGE_SIZE,
        EARN_BADGE_TEMPLATE_BADGE_IMAGE_SIZE
    );
    const {redirectToExternalLink: redirect} = useConfigExternalLink({
        ...externalLink,
        ssoParams: {journeyId, badgeId},
    });

    const handleGotIt = () => {
        redirect?.();
    };

    return (
        <div className='mb-6 bg-primary-dark p-4 pt-14 ml:p-0'>
            <h5 className='leading-6 m-0 mt-2 p-0 text-20 font-bold tracking-[0.2px] text-jumbo'>{subTitle}</h5>
            <h2 className='m-0 mb-8 self-stretch p-0 text-32 font-bold leading-[125%] text-romance ml:mb-4'>{title}</h2>
            <LoyaltyPopupTemplate>
                <LoyaltyPopupTemplate.Body className='relative max-w-[361px] gap-0'>
                    <div className='flex h-[361px] w-full items-center justify-center'>
                        <div className='absolute inset-0 max-h-[361px] overflow-hidden'>
                            {/*@ts-ignore*/}
                            <AppImage
                                src={Background}
                                className='h-full w-full rounded-xl object-cover object-center'
                                alt=''
                            />

                            <div
                                className='absolute inset-0 rounded-xl'
                                style={{
                                    background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 57.62%, #000 86.88%)',
                                }}
                            />

                            <div className='absolute bottom-0 z-10 w-full p-6 text-center text-white'>
                                <h1 className='truncate text-28 font-bold tracking-[-0.39px]'>{journeyName}</h1>

                                <p className='mt-3 truncate text-12 uppercase leading-12 tracking-[0.2em]'>
                                    {description}
                                </p>
                            </div>
                        </div>
                        {/*@ts-ignore*/}
                        <AppImage
                            className='z-10 aspect-square h-[174px] shrink-0'
                            src={formattedBadgeImageUrl}
                            decode={false}
                        />
                    </div>

                    <AemButton primary dark className='m-0 mt-4 w-full px-6 py-3' {...button} onClick={handleGotIt} />
                </LoyaltyPopupTemplate.Body>
            </LoyaltyPopupTemplate>
        </div>
    );
};
